import { useEffect, useState } from 'react';
import * as faceapi from '../../../node_modules/face-api.js/dist/face-api';
import { useVideo } from '../../context/videoContext';

const useFaceApi = (activate) => {
  const [loadedModels, setLoadedModels] = useState(false);
  const [localVideoTrackDOM, setLocalVideoTrackDOM] = useState(null);
  const { room, localTracks } = useVideo();
  const [apiInterval, setApiInterval] = useState(null);
  const [faceApiDetections, setFaceApiDetections] = useState(null);

  useEffect(() => {
    if (!loadedModels) return;

    let facepi = null;

    if (apiInterval) {
      clearInterval(apiInterval);
    }
    if (activate === true && loadedModels) {
      const localVideoTrack = localTracks?.video || (room ? Array.from(room.localParticipant.videoTracks.values())[0]?.track : null);
      const attachedElement = localVideoTrack?._attachments?.values().next().value || null;
      setLocalVideoTrackDOM(attachedElement);

      facepi = setInterval(async () => {
        if (localVideoTrackDOM) {
          const detections = await faceapi.detectSingleFace(localVideoTrackDOM, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks();
          setFaceApiDetections(detections);
        }
      }, 1000);
      setApiInterval(facepi);
    }
    return () => {
      if (apiInterval) {
        clearInterval(apiInterval);
      }

      if (facepi) {
        clearInterval(facepi);
      }
    };
  }, [loadedModels, activate, localVideoTrackDOM]);

  useEffect(() => {
    if (loadedModels) return;

    Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri(`${process.env.PUBLIC_URL}/models`),
      faceapi.nets.faceLandmark68Net.loadFromUri(`${process.env.PUBLIC_URL}/models`),
    ])
      .then(async (val) => {
        setLoadedModels(true);
      })
      .catch((err) => {
        console.log('Error loading models', err);
      });
  }, [loadedModels]);

  return faceApiDetections;
};

export default useFaceApi;
